/** Converte ISO/Date para valor de `<input type="date">`. */
export function toDateInputValue(value?: string | Date | null): string {
  if (!value) return ''
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toISOString().slice(0, 10)
}

/** Converte valor do input date para ISO midnight UTC (API). */
export function dateInputToIso(value: string): string | null {
  if (!value) return null
  const date = new Date(`${value}T12:00:00`)
  if (Number.isNaN(date.getTime())) return null
  return date.toISOString()
}
